export default __webpack_public_path__ + "static/media/eye-hide.a1b1bcba.svg";